module.exports = __webpack_public_path__ + "img/silverware-fork-knife.49c9b99d.svg";